import { Card, Col, Row } from 'antd'

import { ChartBody } from '@/components/charts/chartTheme'
import { RefreshablePageHeader } from '@/components/layout/RefreshablePageHeader'

import { MetricsCharts } from './components/MetricsCharts'
import { PlatformOverview } from './components/PlatformOverview'
import { StatCards } from './components/StatCards'
import { VmBarChart, VmReadinessChart } from './components/VmCharts'
import { useDashboardQueries } from './hooks/useDashboardQueries'

export default function DashboardPage() {
  const q = useDashboardQueries()

  return (
    <div>
      <RefreshablePageHeader
        title="Dashboard"
        queryKey="dashboard"
        queries={q.queries}
      />

      <StatCards
        stats={q.stats}
        activeVms={q.activeVms}
        statsLoading={q.statsLoading}
        storage={q.storage}
        ips={q.ips}
      />

      <PlatformOverview
        stats={q.stats}
        loading={q.statsLoading}
        error={q.statsError}
      />

      <MetricsCharts
        metrics={q.metrics}
        loading={q.metricsLoading}
        error={q.metricsError}
      />

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <Card title="VM Created / Terminated (30 days)">
            <ChartBody
              data={q.vmActivity}
              loading={q.vmActivityLoading}
              errorMessage="Failed to load VM activity"
            >
              {(data) => <VmBarChart data={data} />}
            </ChartBody>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <Card title="Average VM Readiness Time (30 days)">
            <ChartBody
              data={q.vmReadiness}
              loading={q.vmReadinessLoading}
              errorMessage="Failed to load VM readiness"
            >
              {(data) => <VmReadinessChart data={data} />}
            </ChartBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
